<template>
  <d2-container>
    <template slot="header">
      <el-select v-model="query.ownerType" clearable size="small" placeholder="归属类型" style="width: 150px; margin-right: 8px">
        <el-option label="个人" value="PERSONAL"></el-option>
        <el-option label="组织" value="ORGANIZATION"></el-option>
      </el-select>
      <el-input v-model="query.ownerId" clearable size="small" placeholder="归属ID" style="width: 160px; margin-right: 8px"></el-input>
      <el-select v-model="query.billingMode" clearable size="small" placeholder="收费模式" style="width: 180px; margin-right: 8px">
        <el-option v-for="item in billingModes" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="query.status" clearable size="small" placeholder="状态" style="width: 120px; margin-right: 8px">
        <el-option label="有效" :value="1"></el-option>
        <el-option label="失效" :value="0"></el-option>
        <el-option label="取消" :value="2"></el-option>
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="load">搜索</el-button>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="openManualDialog">手动开通</el-button>
    </template>

    <el-table size="small" stripe border :data="records" v-loading="loading">
      <el-table-column prop="id" label="订阅ID" width="150"></el-table-column>
      <el-table-column label="归属类型" width="100">
        <template slot-scope="scope">{{ ownerTypeLabel(scope.row.ownerType) }}</template>
      </el-table-column>
      <el-table-column prop="ownerId" label="归属ID" width="150"></el-table-column>
      <el-table-column prop="planName" label="套餐" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="收费模式" width="160">
        <template slot-scope="scope">{{ billingModeLabel(scope.row.billingMode) }}</template>
      </el-table-column>
      <el-table-column prop="seatCount" label="席位" width="80" align="center"></el-table-column>
      <el-table-column label="Agent Plus" width="105" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.agentPlusEnabled ? 'success' : 'info'">
            {{ scope.row.agentPlusEnabled ? '已开' : '未开' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="LLM额度使用" width="180" align="right">
        <template slot-scope="scope">{{ quotaUsageText(scope.row) }}</template>
      </el-table-column>
      <el-table-column label="额度用尽" width="150">
        <template slot-scope="scope">{{ scope.row.agentPlusEnabled ? llmQuotaPolicyLabel(scope.row.llmQuotaExhaustedPolicy) : '-' }}</template>
      </el-table-column>
      <el-table-column label="无限画布" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.canvasInfinite ? '是' : '否' }}</template>
      </el-table-column>
      <el-table-column prop="dailyPointAmount" label="每日无限积分" width="120" align="right"></el-table-column>
      <el-table-column prop="startAt" label="开始时间" width="170"></el-table-column>
      <el-table-column prop="expireAt" label="过期时间" width="170"></el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">{{ statusText(scope.row.status) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="100" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" :disabled="scope.row.status !== 1" @click="cancel(scope.row)">取消</el-button>
        </template>
      </el-table-column>
    </el-table>

    <template slot="footer">
      <el-pagination
        :current-page.sync="query.currentPage"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSize"
        @current-change="handlePage"
      ></el-pagination>
    </template>

    <el-dialog title="手动开通订阅" :visible.sync="manualDialog" width="760px">
      <el-alert
        class="dialog-alert"
        title="用于后台给指定个人或组织直接开通套餐。同一归属已有未过期订阅时，后端会拒绝开通，避免重复订阅。"
        type="warning"
        :closable="false"
        show-icon
      ></el-alert>

      <el-form :model="manualForm" label-width="128px">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="归属类型" required>
              <el-select v-model="manualForm.ownerType" style="width: 100%" @change="handleManualOwnerTypeChange">
                <el-option label="个人" value="PERSONAL"></el-option>
                <el-option label="组织" value="ORGANIZATION"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="归属ID" required>
              <owner-selector
                v-model="manualForm.ownerId"
                :owner-type="manualForm.ownerType"
                :show-type="false"
                id-min-width="0"
                personal-placeholder="请选择个人账户"
                organization-placeholder="请选择组织"
              ></owner-selector>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="指定套餐" required>
          <el-select
            v-model="manualForm.planId"
            filterable
            :loading="planLoading"
            placeholder="请选择启用中的套餐"
            style="width: 100%"
            @change="handleManualPlanChange"
          >
            <el-option
              v-for="plan in manualPlanOptions"
              :key="plan.id"
              :label="planOptionLabel(plan)"
              :value="plan.id"
            ></el-option>
          </el-select>
          <div v-if="selectedManualPlan" class="field-tip">{{ selectedPlanTip(selectedManualPlan) }}</div>
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="付款账户ID" :required="manualForm.ownerType === 'ORGANIZATION'">
              <account-selector
                v-model="manualForm.payerAccountId"
                placeholder="请选择付款或操作账户"
              ></account-selector>
              <div class="field-tip">个人订阅不填时默认使用归属账号；组织订阅必须指定付款或操作账户。</div>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="manualNeedSeat">
            <el-form-item label="开通席位数">
              <el-input-number v-model="manualForm.seatCount" :min="1" :step="1" style="width: 100%"></el-input-number>
              <div class="field-tip">不低于套餐最小席位，不能超过套餐最大席位。</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="manualDialog = false">取消</el-button>
        <el-button type="primary" :loading="manualSubmitting" @click="submitManual">确认开通</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
import { getSubscriptions, cancelSubscription, getSubscriptionPlans, manualActivateSubscription } from '@/api/ai/rights'
import AccountSelector from '@/components/ai-rights/AccountSelector.vue'
import OwnerSelector from '@/components/ai-rights/OwnerSelector.vue'
import { BILLING_MODE_OPTIONS, billingModeLabel, llmQuotaPolicyLabel, ownerTypeLabel } from './labels'

export default {
  name: 'aiSubscriptionManager',
  components: {
    AccountSelector,
    OwnerSelector
  },
  data () {
    return {
      billingModes: BILLING_MODE_OPTIONS,
      query: { currentPage: 1, pageSize: 20, ownerType: '', ownerId: '', billingMode: '', status: '' },
      records: [],
      total: 0,
      loading: false,
      manualDialog: false,
      manualSubmitting: false,
      planLoading: false,
      plans: [],
      manualForm: this.defaultManualForm()
    }
  },
  computed: {
    manualPlanOptions () {
      return this.plans.filter(plan => plan.targetType === this.manualForm.ownerType)
    },
    selectedManualPlan () {
      return this.plans.find(plan => String(plan.id) === String(this.manualForm.planId)) || null
    },
    manualNeedSeat () {
      return this.selectedManualPlan && this.selectedManualPlan.billingMode === 'ORG_SEAT'
    }
  },
  created () {
    this.load()
  },
  methods: {
    defaultManualForm () {
      return {
        ownerType: 'PERSONAL',
        ownerId: '',
        planId: '',
        payerAccountId: '',
        seatCount: 1
      }
    },
    load () {
      this.loading = true
      getSubscriptions(this.query).then(res => {
        this.records = (res && res.records) || []
        this.total = Number((res && res.total) || 0)
      }).finally(() => {
        this.loading = false
      })
    },
    loadPlans () {
      this.planLoading = true
      getSubscriptionPlans({ currentPage: 1, pageSize: 100, status: 1 }).then(res => {
        this.plans = (res && res.records) || []
      }).finally(() => {
        this.planLoading = false
      })
    },
    handleSize (size) {
      this.query.pageSize = size
      this.load()
    },
    handlePage (page) {
      this.query.currentPage = page
      this.load()
    },
    statusText (status) {
      return status === 1 ? '有效' : (status === 2 ? '取消' : '失效')
    },
    billingModeLabel,
    llmQuotaPolicyLabel,
    ownerTypeLabel,
    openManualDialog () {
      this.manualForm = this.defaultManualForm()
      this.manualDialog = true
      this.loadPlans()
    },
    handleManualOwnerTypeChange () {
      if (this.selectedManualPlan && this.selectedManualPlan.targetType !== this.manualForm.ownerType) {
        this.manualForm.planId = ''
      }
      this.manualForm.ownerId = ''
      if (this.manualForm.ownerType === 'PERSONAL') {
        this.manualForm.payerAccountId = ''
      }
    },
    handleManualPlanChange () {
      if (this.manualNeedSeat) {
        this.manualForm.seatCount = this.selectedManualPlan.minSeatCount || 1
      } else {
        this.manualForm.seatCount = 1
      }
    },
    cancel (row) {
      this.$confirm('确认取消该订阅？', '提示').then(() => {
        cancelSubscription({ id: row.id }).then(() => {
          this.$message.success('已取消')
          this.load()
        })
      })
    },
    submitManual () {
      const ownerId = this.normalizeId(this.manualForm.ownerId)
      const payerAccountId = this.normalizeId(this.manualForm.payerAccountId)
      if (!ownerId) {
        this.$message.error('请填写正确的归属ID')
        return
      }
      if (!this.manualForm.planId) {
        this.$message.error('请选择要开通的套餐')
        return
      }
      if (this.manualForm.ownerType === 'ORGANIZATION' && !payerAccountId) {
        this.$message.error('组织订阅手动开通需填写付款账户ID')
        return
      }

      const payload = {
        ownerType: this.manualForm.ownerType,
        ownerId,
        planId: this.manualForm.planId
      }
      if (payerAccountId) {
        payload.payerAccountId = payerAccountId
      }
      if (this.manualNeedSeat) {
        payload.seatCount = this.manualForm.seatCount
      }

      this.manualSubmitting = true
      manualActivateSubscription(payload).then(() => {
        this.$message.success('开通成功')
        this.manualDialog = false
        this.load()
      }).finally(() => {
        this.manualSubmitting = false
      })
    },
    normalizeId (value) {
      const text = String(value || '').trim()
      return /^\d+$/.test(text) ? text : ''
    },
    planOptionLabel (plan) {
      return `${plan.name}（${this.billingModeLabel(plan.billingMode)} / ID:${plan.id}）`
    },
    selectedPlanTip (plan) {
      const period = `${plan.periodCount || 1}${plan.periodType === 'YEAR' ? '年' : '月'}`
      const plus = plan.agentPlusEnabled ? `Agent Plus，LLM额度 ${this.quotaText(plan.llmQuotaAmount)}` : '未开 Agent Plus'
      const seat = plan.billingMode === 'ORG_SEAT' ? `，席位 ${plan.minSeatCount || 1} 至 ${plan.maxSeatCount || '不限'}` : ''
      return `${this.billingModeLabel(plan.billingMode)}，周期 ${period}，${plus}${seat}`
    },
    quotaUsageText (row) {
      if (!row.agentPlusEnabled) return '-'
      if (row.llmQuotaAmount === null || row.llmQuotaAmount === undefined || row.llmQuotaAmount === '') return '不限额'
      const used = this.formatAmount(row.llmQuotaUsedAmount)
      const total = this.formatAmount(row.llmQuotaAmount)
      const reserved = Number(row.llmQuotaReservedAmount || 0)
      if (reserved > 0) {
        return `已用 ${used} / ${total}（冻结 ${this.formatAmount(row.llmQuotaReservedAmount)}）`
      }
      return `已用 ${used} / ${total}`
    },
    quotaText (value) {
      if (value === null || value === undefined || value === '') return '不限额'
      if (Number(value) === 0) return '无免费额度'
      return this.formatAmount(value)
    },
    formatAmount (value) {
      if (value === null || value === undefined || value === '') return '0'
      const number = Number(value)
      if (!Number.isFinite(number)) return String(value)
      return number.toLocaleString('zh-CN', { maximumFractionDigits: 4 })
    }
  }
}
</script>

<style scoped>
.dialog-alert {
  margin-bottom: 12px;
}

.field-tip {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
</style>
